import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import { getMemberinfo, regPhone, patternPwCker } from "../../utils/utils";
import DaumPostcode from 'react-daum-postcode';

import * as APIS from "../../utils/service";
import queryString from 'query-string';


export default function Mypage({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [memberinfos, setmemberinfos] = useState('');
    const [phoneChflag, setphoneChflag] = useState(false);
    const [companyphoneChflag, setcompanyphoneChflag] = useState(false);
    const [mbpass, setmbpass] = useState('');
    const [mbpass2, setmbpass2] = useState('');
    const [isOpenPost, setIsOpenPost] = useState(false);
    const [addrDatas, setaddrDatas] = useState({});
    const [detail_addr, setdetail_addr] = useState(''); //상세주소
    const [hp, sethp] = useState('');
    const [companyphone, setcompanyphone] = useState('');
    const [errmsg, seterrmsg] = useState(['', '', '', '']);
    const [errmsg2, seterrmsg2] = useState(['', '', '', '']);

    const location = useLocation();

    const query = queryString.parse(location.search);

    const postBoxStyle = {
        display: 'block',
        position: 'relative',
        width: '100%',
        border: '1px solid #000',
        marginTop: 5,
        textAlign: 'right'
    };
    const postCodeStyle = {
        width: '100%',
        borderTop: '1px solid #000',
    };

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        sethp(memberinfos?.hp);
        setcompanyphone(memberinfos?.compony?.company_phone);
        setdetail_addr(memberinfos?.compony?.detail_addr);
        setaddrDatas({
            addr: memberinfos?.compony?.addr,
            sido: memberinfos?.compony?.sido,
            sigungu: memberinfos?.compony?.sigungu
        });

    }, [memberinfos]);

    // useEffect(() => {
    //     if(query?.phone){
    //         sethp(query?.phone);
    //         //setphoneChflag(true);
    //         console.log(query?.phone)
    //         phoneChSubmit(query?.phone);
    //     }
    // }, [query]);

    const levelText = ['', '중개보조원', '공인중개사', '대표공인중개사'];

    useEffect(() => {
        seterrmsg(errmsg?.map((xe, ie) => ''));

    }, [hp, mbpass, mbpass2, detail_addr, addrDatas]);

    const phoneChSubmit = (pramhp = '') => {
        if (pramhp !== '') {
            if (pramhp === '') {
                seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? '휴대폰 번호를 입력해주세요' : xe));
                return;
            }
            if (!regPhone.test(pramhp)) {
                seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? '휴대폰 형식이 올바르지 않습니다.' : xe));
                return;
            }
        } else {
            if (hp === '') {
                seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? '휴대폰 번호를 입력해주세요' : xe));
                return;
            }
            if (!regPhone.test(hp)) {
                seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? '휴대폰 형식이 올바르지 않습니다.' : xe));
                return;
            }
        }


        dispatch(loadingflas({ loading: true }));
        //navigate('/Storeselctor');

        let sender = {
            hp: pramhp !== '' ? pramhp : hp,
            pw: '',
        }

        APIS.postData('/v1/auth/update', sender).then(({ data }) => {
            console.log(data);
            if (data) {
                getMemberinfo(setmemberinfos);
                setphoneChflag(false)
                dispatch(
                    open({
                        component: '설정이 저장되었습니다.',
                        title: '알림',
                        button: "확인",
                        titleviewer: true,
                        alert: false,
                        onPress: () => {
                            navigate('/Mypage');
                            dispatch(close());
                        },
                    })
                );
            }
        }).catch(({ response }) => {
            const { data } = response;
            seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? data?.msg : xe));
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    const companyphoneChSubmit = () => {
        if (companyphone === '') {
            seterrmsg(errmsg2?.map((xe, ie) => ie === 0 ? '대표 번호를 입력해주세요' : xe));
            return;
        }

        dispatch(loadingflas({ loading: true }));
        //navigate('/Storeselctor');

        let sender = {
            hp: '',
            pw: '',
            companyphone: companyphone,
        }
        APIS.postData('/v1/auth/update', sender).then(({ data }) => {
            console.log(data);
            if (data) {
                getMemberinfo(setmemberinfos);
                setcompanyphoneChflag(false)
                navigate('/Mypage');
            }
        }).catch(({ response }) => {
            const { data } = response;
            seterrmsg(errmsg?.map((xe, ie) => ie === 0 ? data?.msg : xe));
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }


    const mbinfoUpdate = () => {

        if (mbpass !== '') {
            if (!patternPwCker.test(mbpass)) {
                seterrmsg(errmsg?.map((xe, ie) => ie === 1 ? '8자리 이상 영문,숫자,특수문자로 입력하세요.' : xe));
                return;
            }
            if (mbpass !== mbpass2) {
                seterrmsg(errmsg?.map((xe, ie) => ie === 1 ? '비밀번호가 일치하지 않습니다.' : xe));
                return;
            }
            if (detail_addr === '') {
                seterrmsg(errmsg?.map((xe, ie) => ie === 2 ? '상세주소를 입력해주세요.' : xe));
                return;
            }
            let sender = {
                hp: '',
                pw: mbpass,
            }
            dispatch(loadingflas({ loading: true }));
            APIS.postData('/v1/auth/update', sender).then(({ data }) => {
                if (data) {
                    dispatch(
                        open({
                            component: '설정이 저장되었습니다.',
                            title: '알림',
                            button: "확인",
                            titleviewer: true,
                            alert: false,
                            onPress: () => {
                                dispatch(close());
                            },
                        })
                    );
                }
            }).catch(({ response }) => {
                const { data } = response;
                seterrmsg(errmsg?.map((xe, ie) => ie === 1 ? data?.msg : xe));
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });
        }
    }
    useEffect(() => {
        // const script = document.createElement('script');
        // const callBackFunc = document.createTextNode(
        //     "function result(result) {" +
        //         "try {" +
        //             "result = JSON.parse(result);" +
        //             "window.location.href='/Mypage?name='+result?.data+'&phone='+result?.phone+'&gender='+result?.gender+'';" +
        //         "} catch (error) {" +
        //         "}" +
        //     "}");
        // script.appendChild(callBackFunc);
        // document.body.appendChild(script);

        window.result = (strData) => {
            try {
                let parseData = JSON.parse(strData);
                console.log("asdfasdfasdf", memberinfos?.name, parseData);
                if(memberinfos?.name !== parseData?.data){
                    // 인증된 이름이 다를경우 처리
                    dispatch(
                        open({
                            component: '인증정보가 가입된 회원정보와 일치하지 않습니다.',
                            title: '알림',
                            button: "확인",
                            titleviewer: true,
                            alert: false,
                            onPress: () => {
                                dispatch(close());
                            },
                        })
                    );
                    return;
                }

                sethp(parseData?.phone);
                phoneChSubmit(parseData?.phone);    
            } catch (error) {}
        }

        return () => {
            // 마이페이지에서 나가게 되었을 경우 result 클리어
            window.result = () => { }
        }
    }, [memberinfos]);
    const mok_popup = () => {
        window.MOBILEOK.process("https://api.maemul.net/mok_std_request", "WB", "result");
    }

    return (
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={0} />
                </div>
                <div className='padding32'>
                    <div className='pagetitle fontsize20 bolds'>개인설정</div>
                    <div className='pagetabs margint20'>
                        <button className='active' onClick={() => { navigate('/Mypage') }}>내정보</button>
                        <button onClick={() => { navigate('/Favoritpage') }}>즐겨찾기</button>
                        <button onClick={() => { navigate('/Blacklists') }}>블랙리스트</button>
                    </div>
                    <div className='padding32 mypageinputsarea'>
                        <div>
                            <div className="inputtextviewtype1 ">
                                <div>회원유형</div>
                                <div>
                                    {levelText[memberinfos?.level * 1]}
                                    ({memberinfos?.certificate_number})
                                </div>
                            </div>
                            <div className="inputtextviewtype1 ">
                                <div>이메일(ID)</div>
                                <div>
                                    {memberinfos?.email}
                                </div>
                            </div>
                            <div className="inputtextviewtype1 ">
                                <div>이름</div>
                                <div>
                                    {memberinfos?.name}
                                </div>
                            </div>
                            <div className="inputtextviewtype1 ">
                                <div>핸드폰번호</div>
                                <div style={{ flexDirection: 'row' }}>
                                    {phoneChflag === true ?
                                        <>
                                            <div>
                                                <Input
                                                    className={`inputs`}
                                                    setValue={sethp}
                                                    value={hp}
                                                    name="mb_phone"
                                                    error={errmsg[0]}
                                                    readOnly={true}
                                                />
                                            </div>
                                            <button type="button" className='links' style={{ marginLeft: 8 }} onClick={() => { phoneChSubmit() }}>
                                                저장
                                            </button>
                                        </>
                                        :
                                        <>
                                            {memberinfos?.hp}
                                            <button type="button" className='links' style={{ marginLeft: 8 }} onClick={() => {
                                                mok_popup();
                                                //setphoneChflag(true)
                                            }}>
                                                변경하기
                                            </button>
                                        </>
                                    }

                                </div>
                            </div>
                            {/* {memberinfos?.level*1 === 3 &&
                            <div className="inputtextviewtype1 ">
                                <div>대표번호</div>
                                <div style={{ flexDirection: 'row' }}>
                                    {companyphoneChflag === true ? 
                                        <>
                                        <div>
                                            <Input  
                                                className={`inputs`}
                                                setValue={setcompanyphone}
                                                value={companyphone}
                                                name="mb_phone"
                                                error={errmsg2[0]}
                                            />  
                                        </div>
                                        <button type="button" className='links' style={{ marginLeft: 8}} onClick={() => companyphoneChSubmit()}>
                                            저장
                                        </button>
                                        </>                                    
                                    :
                                        <>
                                            {memberinfos?.compony?.company_phone}
                                            <button type="button" className='links' style={{ marginLeft: 8}} onClick={() => {
                                                setcompanyphoneChflag(true)
                                            }}>
                                                변경하기
                                            </button>
                                        </>                                    
                                    }

                                </div>
                            </div> } */}

                            <div className="inputviewtype1 ">
                                <div>비밀번호 변경</div>
                                <div>
                                    <Input
                                        className={`inputs`}
                                        type={'password'}
                                        setValue={setmbpass}
                                        value={mbpass}
                                        name="mb_phone"
                                        placeholder={'비밀번호(8자리 이상 영문,숫자,특수문자)'}
                                    />
                                </div>
                            </div>
                            <div className="inputviewtype1 ">
                                <div></div>
                                <div>
                                    <Input
                                        className={`inputs`}
                                        type={'password'}
                                        setValue={setmbpass2}
                                        value={mbpass2}
                                        name="mb_phone"
                                        placeholder={'비밀번호 재입력'}
                                        error={errmsg[1]}
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <Button
                                onPress={() => {
                                    mbinfoUpdate();
                                }}
                                styles={{ width: 200 }}
                                buttonTxt={'저장'}
                            />
                        </div>
                        <div>
                            <p>모두의 매물을 더 이상이용하지 않으신다면</p>
                            <button
                                onClick={() => {
                                    navigate('/Abortpage')
                                }}
                                style={{ textDecoration: 'underline' }}
                            >
                                회원탈퇴하기
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

